export default __webpack_public_path__ + "static/media/33.99b2379a.png";